<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div class="header-statement-services" >
        <h3>Articles</h3>
        <p>Articles written by safety professionals that cover a wide range of topics.</p>
    </div>
    <div class="grid-container-services">
        <div class="item1 service-container">
            <div class="image-cropper">
                <img src="./images/9481.jpg" class="services-image" style="object-position: 18% 38%;">
            </div>
            <div style="margin: 1%;">
                <h3>Consultant Services</h3>
                <p>Flexible, site-specific support tailored to the unique needs of your project.</p>
                <p>Key Features:</p>
                <ul>
                    <li>Safety Audits & Compliance Monitoring</li>
                    <li>Safety Training & Orientations</li>
                    <li>Safety Program Development & Documentation</li>
                </ul>
                <router-link to="/fieldservices"><button class="learnmore-button">Learn More</button></router-link>
            </div>

        </div>
        <div class="item2 service-container">
            <div class="image-cropper">
                <img src="./images/tablet.jpg" class="services-image"
                style="object-position: 18% 54%;">
            </div>
            <div style="margin: 1%;">
                <h3>Gas Monitor Calibration and Repair</h3>
                <p>A convinient and cost effective solution to gas monitor maintnenance and deployment</p>
                <p>Key Features:</p>
                <ul>
                    <li>Gas Monitor Calibration</li>
                    <li>Climate Controlled Storage</li>
                    <li>Rapid Deployment</li>
                </ul>
                <router-link to="/Contact"><button class="learnmore-button">Learn More</button></router-link>
            </div>

        </div>
       <!--  <div class="item3 service-container">
            <div class="image-cropper">
                <img src="./images/computer.jpg" class="services-image" style="object-position: 18% 44%;">
            </div>
            <div style="margin: 1%;">
                <h3>IC Dashboard</h3>
                <p>IC Dashboard brings all your critical project elements into one intuitive interface, empowering teams to stay aligned, informed, and productive.</p>
                <ul>
                    <li>Workforce Management</li>
                    <li>Fleet & Equipment Oversight</li>
                    <li>Document Management</li>
                </ul>
                <router-link to="/icdashboard"><button class="learnmore-button">Learn More</button></router-link>
            </div>

        </div> -->
        <div class="item4 service-container">
            <div class="image-cropper">
                <img src="./images/20241029_133304.jpg" class="services-image" style="object-position: 18% 52%;">
            </div>
            <div style="margin: 1%;">
                <h3>Custom Solutions for Your Needs</h3>
                <p>We understand that every construction site has unique safety challenges.
                    Our experts work closely with your team to develop tailored solutions that address your specific
                    needs.
                    Our collaborative approach ensures that safety programs and training are not only compliant with
                    regulations but also practical and effective for your specific operations.</p>
            </div>

        </div>
    </div>

</template>
<script>
export default {};
</script>

<style>
.header-statement-services{
    text-align: center;
    margin-top: 3%;
    font-family: ui-sans-serif, system-ui, sans-serif;
    background-color: #0e5295; 
    padding: 3% 0% 6%; 
    margin-top: 0%;
}
.header-statement-services h3{
    font-size: 140%; 
    color: white;
}
.header-statement-services p{
    font-size: 100%; 
    color: white; 
    margin: 0% 10%;
}
.grid-container-services {
    display: block;
    height: max-content;
    grid-template-columns: auto;
    grid-gap: 4%;
    padding: 10px;
    width: 74%;
    margin: 0% 13%;

}
.learnmore-button{
    padding: 2% 4%;
    border-radius: 4px;
    border: none;
    color: rgb(255, 255, 255);
    background-color: #0e5295;
    margin: 3% 5%;
    font-size: 80%;
}
.service-container {
    width: 100%;
    height: fit-content;
    box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, .2);
    border-radius: 6px;
    overflow: hidden;
    margin-top: 5%;
}
.service-container h3{
    font-size: large;
}
.service-container p{
    font-size: small;
}
.service-container ul{
    font-size: small;
}
.image-cropper{
    height: 20vh;
    overflow: hidden;
}

.services-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
@media (min-width:640px){
    .header-statement-services{
    text-align: center;
    margin-top: 3%;
    font-family: ui-sans-serif, system-ui, sans-serif;
    background-color: #0e5295; 
    padding: 3% 0% 6%; 
    margin-top: 0%;
}
.header-statement-services h3{
    font-size: 200%; 
    color: white;
}
.header-statement-services p{
    font-size: 100%; 
    color: white; 
    /* max-width: 40%;  */
    margin: 0% 20%;
}
.grid-container-services {
    display: grid;
    grid-template-columns: auto auto;
    height: auto;
    grid-gap: 4%;
    width: 74vw;
    margin: 2% 13%;

}
.learnmore-button{
    padding: 2% 4%;
    border-radius: 4px;
    border: none;
    color: rgb(255, 255, 255);
    background-color: #0e5295;
    margin: 3% 5%;
}
.image-cropper{
    height: 30%;
    overflow: hidden;
}
.service-container {
    width: 35vw;
    height: 100%;
    box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, .2);
    border-radius: 6px;
    overflow: hidden;
}
.service-container h3{
    font-size: xx-large;
}
.service-container p{
    font-size: large;
}
.service-container ul{
    font-size: large;
}
.services-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
}
@media (min-width:1024px){
    .header-statement-services{
    text-align: center;
    margin-top: 3%;
    font-family: ui-sans-serif, system-ui, sans-serif;
    background-color: #0e5295; 
    padding: 3% 0% 6%; 
    margin-top: 0%;
}
.header-statement-services h3{
    font-size: 320%; 
    color: white;
}
.header-statement-services p{
    font-size: 140%; 
    color: white; 
    max-width: 40%; 
    margin: 0% 30%;
}
.grid-container-services {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    row-gap: 1rem;
    column-gap: 1rem;
    height: max-content;
    align-content: start;
    width: 74vw;
    margin: 0% 13%;

}
.image-cropper{
    flex: 0 0 auto;
    height: 20vh;
    overflow: hidden;
}
.service-container {
    width: 35vw;
    height: auto !important;
    max-height:none !important;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, .2);
    border-radius: 6px;
    overflow: hidden;
    margin-top: 0%;
}
.service-container h3{
    font-size: xx-large;
}
.service-container p{
    font-size: large;
}
.service-container ul{
    font-size: large;
}
.services-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.service-container > div:last-child {
  flex: 1;       
}
}
</style>